export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8282.e4c85b33.jpg";